var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"clarification-modal","classes":['modal-window'],"transition":"scale","scrollable":"","adaptive":"","click-to-close":false,"width":"800px","height":"700px"}},[_c('div',{staticClass:"modal-container"},[_c('clarification')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }